<template>
  <!-- Pastilla de grupo de proyecto (mismo color que /select-group, indexado por id del grupo);
       texto limitado + tooltip. Los proyectos sin grupo se muestran "Sin grupo" con chip gris. -->
  <span class="group-tag" :style="style" v-tip="label">{{ label }}</span>
</template>

<script>
  import { tip } from '../shared/tip'

  export default {
    name: 'PrmPortfolioGroupTag',

    directives: { tip },

    props: {
      group: { type: String, default: '' },
      color: { type: String, default: '#94a3b8' }, // gris por defecto ("Sin grupo")
    },

    computed: {
      label () { return this.group || this.$t('prm_portfolio_no_group') },
      // Distintivo del diseño: color de fondo sólido (el real del grupo), texto blanco.
      style () {
        return { background: this.color || '#94a3b8', color: '#fff' }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .group-tag {
    display: inline-block; max-width: 130px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    vertical-align: middle; font-size: 10px; font-weight: 700; padding: 1px 7px; border-radius: 4px;
  }
</style>
